<app-navigation-header id="headerContainer" *ngIf="enableNavigationBar"></app-navigation-header>
<div *ngIf="enableNavigationBar" style="height:70px; display:table; table-layout:fixed; background-color:transparent">
	<!-- top navigation space-->
</div>
<div id="viewTemp" class="h-100 w-100">
	<router-outlet></router-outlet>
</div>
<app-navigation-footer id="footerContainer" *ngIf="enableNavigationBar"></app-navigation-footer>
<app-navigation-idle *ngIf="enableIdleTimeout"></app-navigation-idle>
